export default "__VITE_ASSET__733618ac__"